import React, { memo } from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

import svgSet from "./svgSet";

interface Props {
  name: string;
}

const Icon = ({ name }: Props): JSX.Element => <SvgIcon {...svgSet[name]} />;

export default memo(Icon);
